export default "__VITE_ASSET__ffd85652__"